import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './Column.module.scss';

type ColumnProps = {
  className?: string;
  children?: ReactNode;
  setNodeRef?: (node: HTMLDivElement | null) => void;
} & React.ComponentProps<'div'>;

export const Column: FC<ColumnProps> = (props) => {
  const { children, className, setNodeRef, ...rest } = props;
  return (
    <div ref={setNodeRef} className={cn(styles.column, className)} {...rest}>
      {children}
    </div>
  );
};
